import React, { Component } from "react"
import TagSelect from "./tag_select"
import styled from "styled-components"
import { appStrings } from "../common/strings/app_strings"
import { getItemsArray } from "../../src/util/prop_utils"
import { makeToast } from "../util/toast_util"
import { arraysWithObjectIdEqual } from "../util/random_utils"

const {
    googleCalendarAddTagHeader,
    selectTagDetail,
    submit,
} = appStrings.connectedApps

export class TagCalendarEdit extends Component {
    constructor(props) {
        super(props)
        this.stateSetter = this.stateSetter.bind(this)
        this.state = {
            tags: [],
            changesMade: false,
            previousTags: [],
        }
    }

    componentDidMount() {
        const { config, tags } = this.props
        const stateTags = config.defaultTags.reduce((acc, configTag) => {
            const tag = tags.items[configTag.tagId]
            return tag ? [...acc, tag] : acc
        }, [])
        this.setState({ tags: stateTags, previousTags: stateTags })
    }

    componentDidUpdate(prevProps) {
        const defaultTagsChange = !arraysWithObjectIdEqual(prevProps.config.defaultTags, this.props.config.defaultTags)
        if (defaultTagsChange) {
            const { config, tags } = this.props
            const stateTags = config.defaultTags.reduce((acc, configTag) => {
                const tag = tags.items[configTag.tagId]
                return tag ? [...acc, tag] : acc
            }, [])
            this.setState({ tags: stateTags, changesMade: false })
        }
    }

    stateSetter(field) {
        return value => {
            // if value is not clear (no tags), also store new value as "previousTags"
            const previousTags = value.length ? value : this.state.previousTags
            return this.setState({ [field]: value, changesMade: true, previousTags })
        }
    }

    handleSubmit = () => {
        const { tags, previousTags } = this.state
        const { handleUpdateConfigTags, config, team } = this.props
        const invalidSubmit = !team.isPersonal && tags.length === 0
        if (invalidSubmit) {
            // revert tags to previous tags before clear
            this.setState({ tags: previousTags })

            const ind = "danger"
            const msg = "At least one tag is required."
            makeToast(msg, ind, null)
            return
        }

        handleUpdateConfigTags(config.id, tags)
    }

    render() {
        const { config, teams, team, tags, profile } = this.props
        const { personalTeamId } = profile
        const { teamId } = config
        const tagsArray = getItemsArray(tags)
        const isPersonal = team.isPersonal
        const tagsToShow = isPersonal
            ? tagsArray
            : tagsArray.filter(tag => tag.teamId === teamId)
        return (
            <TagGoogleSelectWrapper>
                <h5>{googleCalendarAddTagHeader}</h5>
                <div className="field-detail">{selectTagDetail}</div>
                <div className="field-wrapper">
                    <div className="tag-select-control">
                        <TagSelect
                            tags={tagsToShow}
                            tagMap={tags.items}
                            teams={teams.items}
                            values={this.state.tags}
                            onValuesChange={this.stateSetter("tags")}
                            placeholder="Tags"
                            autofocus={false}
                            viewerPersonalTeamId={personalTeamId}
                        />
                    </div>
                    {this.state.changesMade && (
                        <span className="link" onClick={this.handleSubmit}>
                            {submit}
                        </span>
                    )}
                </div>
            </TagGoogleSelectWrapper>
        )
    }
}
const TagGoogleSelectWrapper = styled.div`
    h5 {
        padding-top: 10px;
    }
    .field-detail {
        font-weight: 400;
        font-size: small;
        margin: 0;
    }
    .field-wrapper {
        display: flex;
        align-items: center;
        .link {
            display: inline-block;
            margin-left: 20px;
        }
        .tag-select-control {
            width: 500px;
        }
    }
    .react-selectize.bootstrap3.root-node .react-selectize-control {
        border-color: #ccc !important;
        outline: none !important;
        box-shadow: none !important;
    }
    .react-selectize.default.root-node {
        width: 100%;

        .react-selectize-control {
            .react-selectize-search-field-and-selected-values {
                .value-wrapper {
                    margin-top: 2px;
                    margin-bottom: 2px;
                }
                .resizable-input {
                    margin: 0;
                    padding: 0;
                }
            }
        }
    }

    .react-selectize-control {
        height: auto !important;
    }

    .react-selectize.dropdown-menu {
        padding: 0;
        width: initial !important;
        min-width: 300px;
    }

    @media (max-width: 425px) {
        .link {
            margin-left: 5px !important;
        }

        .field-wrapper {
            flex-direction: column;
            align-items: flex-end;
        }
    }

    .option-wrapper {
        padding: 0.6em;
    }

    @media (max-width: 1000px) {
        width: 100% !important;
        #simple-select-style {
            width: 100% !important;
        }
        .tag-select-control {
            max-width: 100%;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/tag_google_config_select.jsx